import { Grid, MenuItem, Tab, Tabs, TextField } from '@mui/material'
import React, { useState } from 'react'
import { gql, useMutation, useQuery } from 'urql'
import FormDialog from '../dialogs/FormDialog'
import { fieldErrors, nonFieldErrors } from '../util/errutil'
import ServiceSlackListForm from './ServiceSlackListForm'

const mutation = gql`
  mutation LinkSlackListToService(
    $serviceID: ID!
    $slackListID: ID
    $newSlackList: CreateSlackListInput
  ) {
    linkSlackListToService(
      serviceID: $serviceID
      slackListID: $slackListID
      newSlackList: $newSlackList
    )
  }
`

const query = gql`
  query {
    slackLists {
      id
      slackListID
      name
    }
    slackUsers {
      id
      name
      email
      teamID
    }
  }
`

export default function ServiceSlackListCreateDialog(props: {
  serviceID: string
  onClose: () => void
}): JSX.Element {
  const [mode, setMode] = useState<'create' | 'link'>('create')
  const [selectedListID, setSelectedListID] = useState('')
  const [value, setValue] = useState<{
    name: string
    owners: string[]
  }>({
    name: '',
    owners: [],
  })

  const [{ fetching, error }, linkSlackList] = useMutation(mutation)
  const [{ data, fetching: dataFetching }] = useQuery({ query })

  const hasLists = data?.slackLists?.length > 0
  const slackUsers = data?.slackUsers || []

  React.useEffect(() => {
    if (!dataFetching && hasLists) {
      setMode('link')
    }
  }, [dataFetching, hasLists])

  return (
    <FormDialog
      title='Add Slack List'
      loading={fetching}
      errors={nonFieldErrors(error)}
      onClose={props.onClose}
      onSubmit={() => {
        if (mode === 'create') {
          linkSlackList(
            {
              serviceID: props.serviceID,
              newSlackList: {
                name: value.name,
                owners: value.owners,
              },
            },
            { additionalTypenames: ['SlackList', 'Service'] },
          ).then((result) => {
            if (result.error) return
            props.onClose()
          })
        } else {
          linkSlackList(
            {
              serviceID: props.serviceID,
              slackListID: selectedListID,
            },
            { additionalTypenames: ['SlackList', 'Service'] },
          ).then((result) => {
            if (result.error) return
            props.onClose()
          })
        }
      }}
      form={
        <Grid container spacing={2}>
          {hasLists && (
            <Grid item xs={12}>
              <Tabs value={mode} onChange={(e, val) => setMode(val)}>
                <Tab label='Select Existing' value='link' />
                <Tab label='Create New' value='create' />
              </Tabs>
            </Grid>
          )}
          {mode === 'create' && (
            <Grid item xs={12}>
              <ServiceSlackListForm
                errors={fieldErrors(error)}
                disabled={fetching}
                value={value}
                users={slackUsers}
                onChange={(value) => setValue(value)}
              />
            </Grid>
          )}
          {mode === 'link' && (
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                label='Select List'
                value={selectedListID}
                onChange={(e) => setSelectedListID(e.target.value)}
              >
                {data?.slackLists.map((l: any) => (
                  <MenuItem key={l.id} value={l.id}>
                    {l.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
        </Grid>
      }
    />
  )
}
